
import {Request} from '@/api/request';
import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch, nextTick,
} from "vue";
import {dateformat} from "@/api/date" ;
import {column} from "@/assets/types/common";
import editList from "@/components/editlist/editlist.vue";
import {useRoute, useRouter} from 'vue-router'
import {validateInput, validateClass} from "@/assets/js/formRules";
const formRules = {
    type: [{required: true, message: '必填', trigger: 'change'}],
    supplier_id: [{required: true, message: '必填', trigger: 'change'}],
    date: [{required: true, message: '必填', trigger: 'change'}],
}
export default defineComponent({
    name: "purchaseInbill",
    components: {editList},
    setup() {
        const setTitle: any = inject("setTitle");
        const headClass = inject("headClass");
        const Router = useRouter();
        let uid: any = 0,
            dialog_show = reactive({
                parts: false,
                carcode: false
            } as any),
            is_save = ref(false),
            dialogNavIndex = ref(0),
            form = ref({
                type: 0,
                takeaway: null,
                car_order_id: null,
                car_name: null,
                parts: [],
                branch_id: null,
                ordersn: null,
                desc: ""
            } as any),
            is_load = ref(false),
            formRef = ref(null),
            checkFormData = (): boolean => {
                
                let zeroNumber = 0;
                for (const parts of form.value.parts) {
                    const partsNumber = Number(parts.reality_number);
                    if (partsNumber != 0) {
                        if (partsNumber < 1 || !Number.isInteger(partsNumber)) {
                            alert('实际入库数量必须为大于等于1的整数')
                            return false;
                        }
                        if (partsNumber > parts.refundable_number) {
                            alert('超过待入库数量')
                            return false;
                        }
                    } else {
                        zeroNumber += 1;
                        if (zeroNumber == form.value.parts.length) {
                            alert('请至少输入一项入库数量')
                            return false;
                        }
                    }
                }
                return true;
                
            },
            _onsubmit = () => {
                if (!checkFormData()) {
                    return;
                }
                is_load.value = true;
                let url = '';
                let myData = {};
                
                myData = form.value;
                url = 'adminapi/Warehouse/purchaseWarehousingEdit'
                
                
                Request.axiosInstance({
                    url: url,
                    data: myData
                }).then((res: any) => {
                    is_load.value = false
                    res.status == 202 && Router.go(-1)
                })
            }
        onMounted(() => {
            
            let title = ''
            is_load.value = true
            title = "采购入库";
            setTitle(["仓库管理", title]);
            
            uid = useRoute().query.uid
            Request.axiosInstance({
                url: 'adminapi/Warehouse/purchaseWarehousingInfo',
                data: {purchase_id: uid}
            }).then((res: any) => {
                form.value = res?.content
                form.value['parts'] = res?.content.list
                for (let i = 0; i < form.value.parts.length; i++) {
                    form.value.parts[i]['reality_number'] = 0
                }
				console.log(form.value.parts)
                form.value.list = null;
                is_load.value = false;
            })
        });
        return {
            dialog_show,
            dialogNavIndex,
            headClass,
            form,
            is_load,
            _onsubmit,
            formRef,
            formRules,
        };
    },
});
